import { render, staticRenderFns } from "./FlowHeader.vue?vue&type=template&id=3e51c156&scoped=true"
import script from "./FlowHeader.vue?vue&type=script&lang=js"
export * from "./FlowHeader.vue?vue&type=script&lang=js"
import style0 from "./FlowHeader.vue?vue&type=style&index=0&id=3e51c156&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e51c156",
  null
  
)

export default component.exports